import { AppState } from "../../../redux-configuration/AppState";
import { ProductDetails } from "../../domain/entities/productDetails";

export const loadProductsLoadingSelector = (appState: AppState): boolean => appState.ecommerce.productList.loading
export const loadProductsErrorSelector = (appState: AppState): string | undefined => appState.ecommerce.productList.error
export const productsSelector = (appState: AppState): ProductDetails[] | undefined => appState.ecommerce.productList.data
